import React from 'react';
import { Phone } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 flex gap-3 z-50 md:hidden shadow-[0_-10px_30px_rgba(15,30,61,0.1)]" data-id="element-1739">
      <a href="tel:5175457772" className="flex-1 flex items-center justify-center gap-2 bg-gray-100 text-navy font-semibold py-3.5 px-4 rounded-xl active:bg-gray-200 transition-colors" aria-label="Call Kosin's Glass" data-id="element-1740">
        <Phone className="w-5 h-5" data-id="element-1741" />
        Call
      </a>
      <a href="#quote-form" className="flex-[1.5] flex items-center justify-center gap-2 bg-primary text-white font-semibold py-3.5 px-4 rounded-xl active:bg-primary-hover transition-colors" data-id="element-1742">
        Request Shower Quote
      </a>
    </div>;
}